export const compose = (...fns) =>
    fns.reduce(
        (acc, d) =>
            (...args) =>
                acc(d(...args)),
    );
